import LabraLogo from '../../../common/images/labraIcon.svg'
import { useStyles } from './PoweredByLabra.styles'

export const PoweredByLabra = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      Powered by{' '}
      <a
        className={classes.labraText}
        target="_blank"
        rel="noopener noreferrer"
        href="https://labra.io"
      >
        <img className={classes.labraImage} src={LabraLogo} alt="Labra" />
        <div>labra</div>
      </a>
    </div>
  )
}
